import { isEqual, omit } from 'lodash';
import {
  LP_DESIGN_CATEGORIES,
  FONT_CASE_KEYWORD,
  FONT_WEIGHT_KEYWORD,
  GRADIENT_TYPES,
  TEXT_ALIGNMENT,
  TEXT_ORIENTATION,
  LP_DESIGN_LOGO,
  LP_DESIGN_SOCIAL_MEDIA,
} from '../constants';
import { IImgProps } from 'lib/components/formik/FormikImageUpload/types';

export interface ILandingPageBuilderBulkEditPayload
  extends ILandingPageBulkEditDesignBase {
  headerLogo: string | null;
  bodyBackgroundImage: string | null;
}

export interface ILandingPageBuilderBulkEditFormData
  extends ILandingPageBulkEditDesignBase {
  headerLogo: IImgProps | null;
  bodyBackgroundImage: IImgProps | null;
}

export interface ILandingPageBulkEditDesignBase {
  title: string | null;
  category: LP_DESIGN_CATEGORIES | null;

  // CTAS
  buttonColor: string | null;
  buttonHoverColor: string | null;
  showButtonBorder: number | null;
  buttonFontCase: FONT_CASE_KEYWORD | null;
  buttonFontWeight: FONT_WEIGHT_KEYWORD | null;
  buttonFontFamily: string | null;
  buttonFontSize: number | null;
  buttonLineHeight: number | null;
  buttonCornerRadius: number | null;
  buttonPaddingY: number | null;
  buttonPaddingX: number | null;
  buttonBorderColor: string | null;
  buttonBorderHoverColor: string | null;
  buttonTextColor: string | null;
  buttonTextHoverColor: string | null;
  // CTAS

  // IMAGE
  gradient: GRADIENT_TYPES | null;
  showGradient: number | null;
  // IMAGE

  // BODY
  fontFamily: string | null;
  bodyFontSize: number | null;
  textColor: string | null;
  bodyBackgroundColor: string | null;
  bodyTextColor: string | null;
  additionalText: string | null;
  additionalTextBackgroundColor: string | null;
  additionalTextColor: string | null;
  additionalTextFontFamily: string | null;
  // BODY

  // HEADER
  headerFontFamily: string | null;
  titleFontSize: number | null;
  headerLineHeight: number | null;
  headerFontWeight: FONT_WEIGHT_KEYWORD | null;
  headerFontCase: FONT_CASE_KEYWORD | null;

  headerBackgroundColor: string | null;
  headerTextColor: string | null;

  showHeaderShadow: number | null;

  headerLogoMaxWidth: number | null;
  headerLogoMaxHeight: number | null;

  showFirstName: number | null;
  showLastName: number | null;
  showPhone1: number | null;
  showPhone2: number | null;
  showDepartment: number | null;
  showTitle: number | null;
  showWebsite: number | null;
  showEmail: number | null;

  headerContentAlignment: TEXT_ALIGNMENT | null;
  headerContentOrientation: TEXT_ORIENTATION | null;

  showContactIcons: number | null;
  // HEADER

  // FOOTER
  showFooterShadow: number | null;
  footerBackgroundColor: string | null;
  footerLogo: LP_DESIGN_LOGO | null;
  showSocialMediaIcons: number | null;
  socialMediaIconType?: LP_DESIGN_SOCIAL_MEDIA | null;
  // FOOTER

  uiKits: null;
  access: null;
  selectedResellerId: null;
}

export const getInitialLandingPageValuesForBulkEdit =
  (): ILandingPageBuilderBulkEditFormData => {
    return {
      title: null,
      category: null,
      fontFamily: null,
      bodyFontSize: null,
      bodyTextColor: null,
      textColor: null,
      buttonColor: null,
      buttonHoverColor: null,
      bodyBackgroundImage: {
        url: '',
        file: null,
      },
      showButtonBorder: null,
      buttonFontCase: null,
      buttonFontWeight: null,
      buttonFontFamily: null,
      buttonFontSize: null,
      buttonLineHeight: null,
      buttonCornerRadius: null,
      buttonPaddingY: null,
      buttonPaddingX: null,
      buttonBorderColor: null,
      buttonBorderHoverColor: null,
      buttonTextColor: null,
      buttonTextHoverColor: null,
      bodyBackgroundColor: null,
      additionalText: null,
      additionalTextBackgroundColor: null,
      additionalTextColor: null,
      additionalTextFontFamily: null,
      headerBackgroundColor: null,
      headerTextColor: null,
      showContactIcons: null,
      showFirstName: null,
      showLastName: null,
      showPhone1: null,
      showPhone2: null,
      showDepartment: null,
      showTitle: null,
      showWebsite: null,
      showEmail: null,
      showHeaderShadow: null,
      showFooterShadow: null,
      headerLogoMaxWidth: null,
      headerLogoMaxHeight: null,
      headerContentAlignment: null,
      headerContentOrientation: null,
      headerFontCase: null,
      headerFontWeight: null,
      headerLogo: {
        url: '',
        file: null,
      },
      titleFontSize: null,
      headerLineHeight: null,
      headerFontFamily: null,
      footerBackgroundColor: null,
      footerLogo: null,
      showSocialMediaIcons: null,
      socialMediaIconType: null,
      showGradient: null,
      gradient: null,
      uiKits: null,
      access: null,
      selectedResellerId: null,
    };
  };

export const areBulkValuesUnchanged = (
  values: ILandingPageBuilderBulkEditFormData
) => {
  const initial = getInitialLandingPageValuesForBulkEdit();
  const fieldsToOmit = ['uiKits', 'access', 'category'];
  const cleanedCurrent = omit(values, fieldsToOmit);
  const cleanedInitial = omit(initial, fieldsToOmit);

  return isEqual(cleanedCurrent, cleanedInitial);
};
